import { ActivityLogsData } from 'store/reducers/activity-log/get-activity-logs/types';

export const GET_USER_ACTIVITY_LOGS_REQUEST = 'GET_USER_ACTIVITY_LOGS_REQUEST';
export const GET_USER_ACTIVITY_LOGS_SUCCESS = 'GET_USER_ACTIVITY_LOGS_SUCCESS';
export const GET_USER_ACTIVITY_LOGS_FAILURE = 'GET_USER_ACTIVITY_LOGS_FAILURE';

interface GetUserActivityLogsRequest {
  type: typeof GET_USER_ACTIVITY_LOGS_REQUEST;
};

interface GetUserActivityLogsSuccess {
  type: typeof GET_USER_ACTIVITY_LOGS_SUCCESS;
  contents: ActivityLogsData;
}

interface GetUserActivityLogsFailure {
  type: typeof GET_USER_ACTIVITY_LOGS_FAILURE;
}

export type GetUserActivityLogsActionTypes = GetUserActivityLogsRequest | GetUserActivityLogsSuccess | GetUserActivityLogsFailure;
